<!--
 * @Author: ljc_625738144@qq.com
 * @Date: 2023-09-27 15:43:16
 * @LastEditors: ljc_625738144@qq.com
 * @LastEditTime: 2025-05-21 10:24:33
 * @Description:
 * @FilePath: \haozhang_pro\src\components\dialog\userHelp.vue
-->
<template>
	<el-card id="userHelp">
		<div>
			<span class="f14 title">客服电话：4000-028-456</span>
			<div class="userContent">
				<span class="f12 color999">官方网站：<a href="http://www.haozhangxiansheng.com" target="_blank">http://www.haozhangxiansheng.com</a></span>
			</div>
		</div>
		<div class="item" @click='handleClick_help("czsc")'>
			<i class="iconfont iconoperation"></i>
			<span class="item_text" >操作手册</span>
		</div>
		<!-- <div class="item" @click='handleClick_help("cjwt")'>
			<i class="iconfont iconproblem"></i>
			<span class="item_text">常见问题</span>
		</div> -->
		<div class="item" @click='handleClick_help("ggls")'>
			<i class="iconfont iconfeedback"></i>
			<span class="item_text">系统公告</span>
		</div>
    <!-- <system-bulletin :defaultData="defaultData" @closed="close"></system-bulletin> -->
	</el-card>
</template>
<script>
  import bus from '@/assets/utils/bus'
  // import systemBulletin from "@/components/dialog/SystemBulletin.vue";
	export default {
    // components:{
    // 	systemBulletin
    // },
		data() {
			return {
				datas:{},
        // defaultData:{
        //   show:false
        // }
			}
		},
		created() {

		},
		methods: {
      close(val){
        this.$set(this.defaultData,'show',val)
      },
			handleClick_help(type) {
        switch (type) {
          case "czsc":
            window.open("https://j15pww5pl0.feishu.cn/wiki/FBP0wjfnyibYS5kGu8XcnSj4nLd",'_blank');
            break;
          case "ggls":
            bus.$emit('showhistory',true)
            // this.$set(this.defaultData,'show',true)
            break;
          default:
          // this.$message({
          // 	type: 'warning',
          // 	message: '功能即将开放，敬请期待!'
          // })
        }

			}
		},
	}
</script>
<style lang="less">
	#userHelp {
		.title {
			color: #333;
			font-weight: 600;
		}
		.userContent {
			padding: 10px 0 30px 0;
		}
		.item {
			border-top: 1px solid #EEEEEE;
			padding: 15px 0;
			display: flex;
			cursor: pointer;
			align-items: center;
			.iconoperation{ font-size: 18px; }
			.iconproblem { font-size: 24px; }
			.iconfeedback { font-size: 20px }
			span { margin-left: 20px; }
			.item_text {
				font-size: 14px;
				color: #333;
			}
		}
		.item:last-child {
			padding-bottom: 10px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/dialog/userHelp.vue